import { computed } from "vue";
import { ModalStoreModule } from "./modules/modalState";
import store from ".";

export const useModalStore = () => {
  if (!store.hasModule('modalStore')) store.registerModule('modalStore', ModalStoreModule);

  return {
    modals: computed(() => store.state.modalStore.modals),
    /** @param {{ name: string, value: boolean }} payload */
    addModal: (payload) => store.dispatch('modalStore/addModal', payload),
    removeModal: (name) => store.dispatch('modalStore/removeModal', name),
    openModal: (name) => store.dispatch('modalStore/openModal', name),
    closeModal: (name) => store.dispatch('modalStore/closeModal', name),
  };
};
